export default __webpack_public_path__ + "static/media/hero-mobile2026.2473ef16.png";